import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import LangEnum from '../../../../../lang/LangEnum';
import { useTranslation } from '../../../../translation/TranslationContext';

export interface OAuthEmailFormValues {
  email: string;
}

interface UseOAuthEmailFormParams {
  onSubmit: (values: OAuthEmailFormValues) => Promise<void>;
}

const useOAuthEmailForm = ({ onSubmit }: UseOAuthEmailFormParams) => {
  const { translate } = useTranslation();

  const schema = z.object({
    email: z
      .string()
      .trim()
      .min(1, translate(LangEnum.GLOBAL_REQUIRED))
      .pipe(z.email(translate(LangEnum.GLOBAL_INVALID_EMAIL))),
  });

  const form = useForm<z.infer<typeof schema>>({
    resolver: zodResolver(schema),
    defaultValues: { email: '' },
    mode: 'onBlur',
  });

  const handleSubmit = form.handleSubmit(async ({ email }) => {
    await onSubmit({ email });
  });

  return { form, handleSubmit };
};

export default useOAuthEmailForm;
